export const Error_Types = Object.freeze({
  PARTIAL_ERROR: 'PARTIAL_ERROR',
  FULL_ERROR: 'FULL_ERROR',
});
